module.exports = __webpack_public_path__ + "img/product_easytag.ad01ab6e.png";